import { createCustomTag, deleteCustomTag, fetchCustomTags, updateCustomTag } from './custom-tags'

const customTagsApi = {
  fetchCustomTags: {
    key: 'FETCH_CUSTOM_TAGS',
    fn: fetchCustomTags,
  },
  createCustomTag: {
    key: 'CREATE_CUSTOM_TAG',
    fn: createCustomTag,
  },
  deleteCustomTag: {
    key: 'DELETE_CUSTOM_TAG',
    fn: deleteCustomTag,
  },
  updateCustomTag: {
    key: 'UPDATE_CUSTOM_TAG',
    fn: updateCustomTag,
  },
}

export default customTagsApi
